import type { CSSProperties } from 'react';

export const ESG_PLATFORM_LOGO_SRC = '/images/esg_light.png';

export const reportMuted: CSSProperties = {
  color: '#334155',
  fontSize: '9pt',
};
